module.exports = __webpack_public_path__ + "img/card-small-b2.5e304fbc.png";